import type { HeatmapRange } from "features/shared/components/heatmap/types";

import { Stack } from "@mui/material";
import { formatHeatmapValue, HEATMAP_BUCKET_CLASSES } from "features/shared/components/heatmap/heatmapScale";
import { useTranslation } from "react-i18next";

export const ScheduleHeatmapLegend = ({ range }: { range: HeatmapRange }) => {
  const { t } = useTranslation();

  return (
    <Stack className="flex-wrap justify-between gap-4">
      <Stack className="gap-3">
        <span className="text-lds-foreground-muted font-ds-body-regular-xs">{formatHeatmapValue(range.min)}</span>
        <Stack className="h-3 w-40 overflow-hidden rounded-ds-pill">
          {HEATMAP_BUCKET_CLASSES.map((className, index) => (
            <span className={`h-full w-full ${className}`} key={index} />
          ))}
        </Stack>
        <span className="text-lds-foreground-muted font-ds-body-regular-xs">{formatHeatmapValue(range.max)}</span>
      </Stack>
      <span className="text-lds-foreground-muted font-ds-body-regular-xs">
        {t("Execution.schedules.clickCellsHint")}
      </span>
    </Stack>
  );
};
